import {
  SourcingPerformanceCriteria,
  SourcingPerformanceStatus,
} from 'api-clients/monolith';
import clsx from 'clsx';
import _round from 'lodash/round';

import { usePerformanceStatus } from '@/components/base/performance-status-pill/use-performance-status';
import { Skeleton } from '@/components/ui/skeleton';
import { Tooltip } from '@/components/ui/tooltip';
import { Typography } from '@/components/ui/typography';

interface PerformanceStatusPillProps {
  status: SourcingPerformanceStatus;
  criteria: SourcingPerformanceCriteria;
  expected: number | null;
  actual: number | null;
  startDate?: string | null;
  endDate?: string | null;
  duration?: number;
  manageHiringGoalLink?: string;
}

export function PerformanceStatusPill({
  status,
  criteria,
  expected,
  actual,
  startDate,
  endDate,
  duration,
  manageHiringGoalLink,
}: PerformanceStatusPillProps) {
  const { bgColor, icon, tooltip, title } = usePerformanceStatus({
    status,
    criteria,
    expected: _round(expected ?? 0),
    actual: _round(actual ?? 0),
    startDate,
    endDate,
    duration,
    manageHiringGoalLink,
  });

  if (!status) return null;

  return (
    <Tooltip content={tooltip}>
      <div
        className={clsx(
          'flex h-6 w-fit items-center justify-center gap-1 whitespace-nowrap rounded-full pl-2 pr-3',
          bgColor,
        )}
      >
        <img src={icon} alt="Status" />
        <Typography variant="small1" className="!text-fx-neutral-600">
          {title}
        </Typography>
      </div>
    </Tooltip>
  );
}

PerformanceStatusPill.Skeleton = function StatusPillSkeleton() {
  return <Skeleton className="w-18 h-6 !rounded-full" />;
};
